import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScannerPage from './components/pages/ScannerPage';
import ContactPage from './components/pages/ContactPage';
import ContactDetailPage from './components/pages/ContactDetailPage';
import GuidePage from './components/pages/GuidePage';
import FeedbackPage from './components/pages/FeedbackPage';
import { APP_CONFIG } from './configs/config';

export default function App() {
  const ExternalRedirect = ({ url }) => {
    React.useEffect(() => {
      window.location.replace(url);
    }, [url]);
    return null;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 flex flex-col">
      <Router>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<ScannerPage />} />
            <Route path="/contacts" element={<ContactPage />} />
            <Route path="/contacts/details" element={<ContactDetailPage />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="*" element={<ExternalRedirect url={APP_CONFIG.MAIN_WEBSITE_ORIGIN} />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

